export default "__VITE_ASSET__CxoBJSRS__"